import { BusinessProfileConstants } from './BusinessProfile.constants';

const initialState = {
};

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case BusinessProfileConstants.UPDATE_BUSINESS_PROFILE_SUCCESS:
      return {
        ...state,
          ...action.payload
      };

    case BusinessProfileConstants.GET_LINKED_ADDRESS_LIST_REQUEST:
      return {
        ...state,
        linkedAddressList: { loading: true, error: false }
      };
    case BusinessProfileConstants.GET_LINKED_ADDRESS_LIST_SUCCESS:
      return {
        ...state,
        linkedAddressList: { loading: false, error: false, ...action.payload }
      };
    case BusinessProfileConstants.GET_LINKED_ADDRESS_LIST_FAILED:
      return {
        ...state,
        linkedAddressList: { loading: false, error: true }
      };
      case BusinessProfileConstants.GET_LINKED_PROFILE_LIST_REQUEST:
      return {
        ...state,
        linkedProfileList: { loading: true, error: false }
      };
      case BusinessProfileConstants.GET_LINKED_PROFILE_LIST_SUCCESS:
        return {
          ...state,
          linkedProfileList: { loading: false, error: false, ...action.payload }
        };
      case BusinessProfileConstants.GET_LINKED_PROFILE_LIST_FAILED:
        return {
          ...state,
          linkedProfileList: { loading: false, error: true }
        };
    default:
      return state;
  }
}
